import React, {
  useEffect,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  FiSearch,
  FiRefreshCw,
  FiFilter,
  FiX,
} from "react-icons/fi";


function CategoryFilter({
  titleAr,
  setTitleAr,
  titleEn,
  setTitleEn,
}) {
  const {
    t,
  } = useTranslation();


  /* =====================================
      LOCAL SEARCH VALUES
  ====================================== */

  const [
    fTitleAr,
    setFTitleAr,
  ] = useState(
    titleAr || ""
  );


  const [
    fTitleEn,
    setFTitleEn,
  ] = useState(
    titleEn || ""
  );


  /* =====================================
      SYNC FROM PARENT
  ====================================== */

  useEffect(() => {
    setFTitleAr(
      titleAr || ""
    );
  }, [
    titleAr,
  ]);


  useEffect(() => {
    setFTitleEn(
      titleEn || ""
    );
  }, [
    titleEn,
  ]);


  /* =====================================
      SEARCH
  ====================================== */

  const handleSearch = () => {

    if (
      setTitleAr
    ) {
      setTitleAr(
        fTitleAr.trim()
      );
    }


    if (
      setTitleEn
    ) {
      setTitleEn(
        fTitleEn.trim()
      );
    }

  };


  /* =====================================
      RESET
  ====================================== */

  const handleReset = () => {

    setFTitleAr("");
    setFTitleEn("");


    if (
      setTitleAr
    ) {
      setTitleAr("");
    }


    if (
      setTitleEn
    ) {
      setTitleEn("");
    }

  };


  /* =====================================
      CLEAR ARABIC
  ====================================== */

  const clearArabic = () => {

    setFTitleAr("");


    if (
      titleAr
    ) {
      setTitleAr("");
    }

  };


  /* =====================================
      CLEAR ENGLISH
  ====================================== */

  const clearEnglish = () => {

    setFTitleEn("");


    if (
      titleEn
    ) {
      setTitleEn("");
    }

  };


  /* =====================================
      ENTER KEY
  ====================================== */

  const handleKeyDown =
    (e) => {

      if (
        e.key === "Enter"
      ) {
        e.preventDefault();

        handleSearch();
      }

    };


  const hasSearch =
    Boolean(
      fTitleAr ||
      fTitleEn ||
      titleAr ||
      titleEn
    );


  return (
    <div
      className="
        w-full
      "
    >

      {/* =================================
          FIELDS
      ================================= */}

      <div
        className="
          grid

          grid-cols-1

          lg:grid-cols-[1fr_1fr_auto]

          gap-3

          items-end
        "
      >

        {/* =================================
            ARABIC SEARCH
        ================================= */}

        <div
          className="
            w-full
          "
        >

          <label
            className="
              block

              mb-2

              font-kufi
              font-medium

              text-[10px]
              md:text-xs

              text-color-2/65
              dark:text-white/55
            "
          >
            {t(
              "Title (Ar)"
            )}
          </label>


          <div
            className="
              group

              relative

              flex

              h-[48px]

              items-center

              overflow-hidden

              rounded-[1rem]

              border
              border-color-2/10
              dark:border-white/10

              bg-back-secondary/60
              dark:bg-back-darkprimery/60

              transition-all
              duration-300

              focus-within:border-color-1/60

              focus-within:bg-back-primery
              dark:focus-within:bg-back-darksecondary

              focus-within:shadow-[0_0_0_3px_rgba(165,119,58,.08)]
            "
          >

            {/* Search Icon */}

            <div
              className="
                flex

                w-12
                h-full

                shrink-0

                items-center
                justify-center

                text-color-1
              "
            >
              <FiSearch
                size={16}
              />
            </div>


            {/* Input */}

            <input
              type="text"

              dir="rtl"

              value={
                fTitleAr
              }

              onChange={(
                e
              ) =>
                setFTitleAr(
                  e.target.value
                )
              }

              onKeyDown={
                handleKeyDown
              }

              placeholder={t(
                "Search Arabic category"
              )}

              className="
                h-full
                w-full

                bg-transparent

                px-1

                font-kufi
                text-xs

                text-color-2
                dark:text-white

                placeholder:text-color-2/30
                dark:placeholder:text-white/25

                outline-none
              "
            />


            {/* Clear */}

            {fTitleAr && (

              <button
                type="button"

                onClick={
                  clearArabic
                }

                className="
                  flex

                  w-10
                  h-full

                  shrink-0

                  items-center
                  justify-center

                  text-color-2/35

                  transition-colors

                  hover:text-color-1
                "
              >
                <FiX
                  size={15}
                />
              </button>

            )}

          </div>

        </div>


        {/* =================================
            ENGLISH SEARCH
        ================================= */}

        <div
          className="
            w-full
          "
        >

          <label
            className="
              block

              mb-2

              font-kufi
              font-medium

              text-[10px]
              md:text-xs

              text-color-2/65
              dark:text-white/55
            "
          >
            {t(
              "Title (En)"
            )}
          </label>


          <div
            className="
              group

              relative

              flex

              h-[48px]

              items-center

              overflow-hidden

              rounded-[1rem]

              border
              border-color-2/10
              dark:border-white/10

              bg-back-secondary/60
              dark:bg-back-darkprimery/60

              transition-all
              duration-300

              focus-within:border-color-1/60

              focus-within:bg-back-primery
              dark:focus-within:bg-back-darksecondary

              focus-within:shadow-[0_0_0_3px_rgba(165,119,58,.08)]
            "
          >

            {/* Search Icon */}

            <div
              className="
                flex

                w-12
                h-full

                shrink-0

                items-center
                justify-center

                text-color-1
              "
            >
              <FiSearch
                size={16}
              />
            </div>


            {/* Input */}

            <input
              type="text"

              dir="ltr"

              value={
                fTitleEn
              }

              onChange={(
                e
              ) =>
                setFTitleEn(
                  e.target.value
                )
              }

              onKeyDown={
                handleKeyDown
              }

              placeholder={t(
                "Search English category"
              )}

              className="
                h-full
                w-full

                bg-transparent

                px-1

                text-xs

                text-color-2
                dark:text-white

                placeholder:text-color-2/30
                dark:placeholder:text-white/25

                outline-none
              "
            />


            {/* Clear */}

            {fTitleEn && (

              <button
                type="button"

                onClick={
                  clearEnglish
                }

                className="
                  flex

                  w-10
                  h-full

                  shrink-0

                  items-center
                  justify-center

                  text-color-2/35

                  transition-colors

                  hover:text-color-1
                "
              >
                <FiX
                  size={15}
                />
              </button>

            )}

          </div>

        </div>


        {/* =================================
            ACTIONS
        ================================= */}

        <div
          className="
            flex

            items-center

            gap-2
          "
        >

          {/* Search */}

          <button
            type="button"

            onClick={
              handleSearch
            }

            className="
              flex

              h-[48px]

              flex-1
              lg:flex-none

              items-center
              justify-center

              gap-2

              rounded-[1rem]

              bg-color-1

              px-5

              font-kufi
              font-medium

              text-xs

              text-white

              whitespace-nowrap

              transition-all
              duration-300

              hover:bg-color-2

              hover:shadow-[0_8px_22px_rgba(165,119,58,.22)]

              active:scale-[0.98]
            "
          >
            <FiSearch
              size={15}
            />

            {t(
              "Search"
            )}
          </button>


          {/* Reset */}

          <button
            type="button"

            onClick={
              handleReset
            }

            disabled={
              !hasSearch
            }

            title={
              t("Reset")
            }

            className="
              flex

              w-[48px]
              h-[48px]

              shrink-0

              items-center
              justify-center

              rounded-[1rem]

              border
              border-color-1/15

              bg-color-1/5

              text-color-1

              transition-all
              duration-300

              hover:border-color-1
              hover:bg-color-1
              hover:text-white

              disabled:cursor-not-allowed
              disabled:opacity-30
            "
          >
            <FiRefreshCw
              size={16}
            />
          </button>

        </div>

      </div>


      {/* =================================
          ACTIVE FILTER
      ================================= */}

      {(titleAr ||
        titleEn) && (

        <div
          className="
            flex
            flex-wrap

            items-center

            gap-2

            mt-3
          "
        >

          <div
            className="
              flex

              items-center

              gap-2

              font-kufi
              text-[9px]

              text-color-2/45
              dark:text-white/35
            "
          >
            <FiFilter
              className="
                text-color-1
              "
            />

            {t(
              "Active Filters"
            )}
          </div>


          {titleAr && (

            <button
              type="button"

              onClick={
                clearArabic
              }

              className="
                flex

                items-center

                gap-2

                rounded-full

                bg-color-1/10

                px-3
                py-1.5

                font-kufi
                text-[9px]

                text-color-1

                transition-colors

                hover:bg-color-1
                hover:text-white
              "
            >
              <span>
                {titleAr}
              </span>

              <FiX
                size={11}
              />
            </button>

          )}


          {titleEn && (

            <button
              type="button"

              onClick={
                clearEnglish
              }

              className="
                flex

                items-center

                gap-2

                rounded-full

                bg-color-1/10

                px-3
                py-1.5

                text-[9px]

                text-color-1

                transition-colors

                hover:bg-color-1
                hover:text-white
              "
            >
              <span
                dir="ltr"
              >
                {titleEn}
              </span>

              <FiX
                size={11}
              />
            </button>

          )}

        </div>

      )}

    </div>
  );
}


export default CategoryFilter;